import { BASE_PATH_URL } from 'shared/constants/base-path-url'

export const formPath = (path: string, withBasePath = true) => {
  if (withBasePath) {
    return `${BASE_PATH_URL}${path}`
  }

  return path
}
